import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ButtonModule, ProgressModule, TableModule, UtilsModule } from '@mtgame/ui';
import { StatisticTableComponent } from './statistic-table.component';
import { TournamentTeamStaffComponent } from '../../app/tournament-team/tournament-team-staff/tournament-team-staff.component';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    TableModule,
    UtilsModule,
    RouterModule,
    SharedModule,
    ButtonModule,
    ProgressModule
  ],
  declarations: [
    StatisticTableComponent,
    TournamentTeamStaffComponent,
  ],
  exports: [
    StatisticTableComponent,
    TournamentTeamStaffComponent,
  ]
})
export class StatisticTableModule {}
